export default {
    "Home": "Hogar",
    "Dashboard": "Panel",
    "Current players total balance": "Saldo total de dispositivos actuales",
    "Total active players count": "Recuento total de dispositivos activos",
    "Players": "Dispositivos",
    "Players List": "Lista de dispositivos",
    "Back to Players List": "Volver a la lista de dispositivos",
    "Back to Player Detail": "Volver al detalle del dispositivo",
    "Username": "Nombre de usuario",
    "Created At": "Creado en",
    "Actions": "Comportamiento",
    "Create": "Crear",
    "Create Player": "Crear dispositivo",
    "New Player": "Nuevo dispositivo",
    "Activate": "Activar",
    "Deactivate": "Desactivar",
    "View": "Vista",
    "Details": "Detalles",
    "Next": "Próximo",
    "Previous": "Anterior",
    "Filter": "Filtrar",
    "Reset": "Reiniciar",
    "Search": "Buscar",
    "Random Username": "Nombre de usuario aleatorio",
    "Status": "Estado",
    "Active": "Activo",
    "Inactive": "Inactivo",
    "No open withdrawals": "No hay retiros abiertos",
    "Open Withdrawal": "Retiro abierto",
    "Current player's balance": "Saldo del dispositivo actual",
    "Accept": "Aceptar",
    "Deposit": "Depósito",
    "Balance": "Balance",
    "Withdraw": "Retirar",
    "Withdrawal of": "Retiro de",
    "for": "para",
    "of": "de",
    "Amount": "Cantidad",
    "PIN": "ALFILER",
    "Games": "Juegos",
    "No Entries": "No entrar",
    "Change Password": "Cambiar la contraseña",
    "Current password": "Contraseña actual",
    "New Password": "Nueva contraseña",
    "New Password Confirmation": "Nueva confirmación de contraseña",
    "Stats": "Estadísticas",
    "Login": "Acceso",
    "Please activate the player before depositing": "Por favor active el dispositivo antes de depositar",
    "Logout": "Cerrar sesión",
    "History": "Historia",
    "Type": "Tipo",
    "All": "Todo",
    "Stats Per Game": "Estadísticas por juego",
    "Stats Per Device": "Estadísticas por dispositivo",
    "Are you sure you want to deposit - ": "¿Estás seguro de que quieres depositar? ",
    "Are you sure you want to withdraw - ": "¿Está seguro de que desea retirarse? ",
    "Please show this code to cashier": "Por favor muestre este código al cajero.",
    "Cancel withdrawal": "Cancelar retiro",
    "and continue playing": "y seguir jugando",
    "Withdraw money": "Retirar dinero",
    "Custom Amount": "Cantidad personalizada",
    "Bingo": "Bingo",
    "Slot": "Ranura",
    "No game found": "No se encontró ningún juego",
    "From": "De",
    "To": "A",
    "Hold": "Ganancia",
    "Bets": "Apuestas",
    "Wins": "Devoluciones",
    "Game Name": "Juego",
    "Share": "Compartir",
    "New Withdrawal": "Nuevo retiro",
    "Spins": "Giros",
    "Stake/Spin": "Apuesta/giro",
    "Totals": "Totales",
    "Save Changes": "Guardar cambios",
    "Save": "Ahorrar",
    "Last Login": "Último acceso",
    "Never": "Nunca",
    "Back": "Atrás",
    "Withdrawals": "Retiros",
    "Withdrawal": "Retiro",
    "Deposits": "Depósitos",
    "Go Home": "Vete a casa",
    "Business Day": "Día laboral",
    "Accounting": "Contabilidad",
    "requested a withdrawal": "solicitó un retiro",
    "canceled a withdrawal": "canceló un retiro",
    "Lobby": "Vestíbulo",
    "Sorry": "Lo siento",
    "Game is not available": "El juego no está disponible.",
    "Withdrawal error": "error de retiro",
    "Insufficient funds": "Fondos insuficientes",
    "Confirm": "Confirmar",
    "Cancel": "Cancelar",
    "Are you sure you want to withdraw all funds?": "¿Está seguro de que desea retirar todos los fondos?",
    "Cancel Withdrawal": "Cancelar retiro",
    "Are you sure you want to cancel withdrawal request?": "¿Está seguro de que desea cancelar la solicitud de retiro?",
    "Yes": "Sí",
    "No": "No",
    "Withdrawal canceled": "Retiro cancelado",
    "Please wait": "Espere por favor",
    "Force reload": "Forzar recarga",
    "Are you sure you want to reload player page?": "¿Estás seguro de que quieres recargar la página del jugador?",
    "impersonated as": "personificado como",
    "Summary per location": "Resumen por barra",
    "Summary per operator": "Resumen por gerente de bar",
    "Deposits total sum": "Suma total de depósitos",
    "Withdrawals total sum": "Suma total de retiros",
    "Withdrawals pending count": "Retiros pendientes de conteo",
    "Unlock Withdrawals": "Desbloquear retiros",
    "Withdrawal confirmation text": "¿Estás seguro de que quieres desbloquear retiros? ",
    "Terminal withdrawals are unblocked": "Los retiros de terminal están desbloqueados",
    "Withdraw all from player confirmation": "¿Estás seguro de que quieres retirar el dinero de los jugadores?",
    "You have unfinished rounds!": "¡Tienes rondas sin terminar!",
    "Open game": "Juego abierto",
}
